import MessageSettingConfig from './MessageSettingConfig';
import './style/index.less';

export default MessageSettingConfig;
